import { Routes } from '@angular/router';
import { Role } from '../../core/enums/role.enum';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';

export const confirmacaoInteresseVagaRoutes: Routes = [
  {
    path: 'confirmacao-interesse-vaga',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    data: {
      title: 'Confirmação de Interesse de Vaga',
      breadcrumb: [{ label: 'Confirmação de Interesse de Vaga' }],
    },
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./confirmacao-interesse-vaga').then(
            (m) => m.ConfirmacaoInteresseVagaComponent
          ),
        data: {
          title: 'Confirmação de Interesse de Vaga',
          roles: [Role.ROLE_CONFIRMACAO_INTERESSE_VAGA_CONSULTAR],
          breadcrumb: [
            { label: 'Confirmação de Interesse de Vaga', url: '/confirmacao-interesse-vaga' },
          ],
        },
      },
    ],
  },
];
